import { Component, OnInit } from '@angular/core';
import { TitleService } from '@kservice';

@Component({
  selector: 'kp-screen-mobile-app-info',
  templateUrl: './screen-mobile-app-info.component.html',
  styleUrls: ['./screen-mobile-app-info.component.scss'],
})
export class ScreenMobileAppInfoComponent implements OnInit {
  private readonly title = 'Mobile App';

  public constructor(private titleService: TitleService) {}

  ngOnInit(): void {
    this.titleService.set(this.title);
  }
}
